<script setup lang="ts">
import type { Player } from '@/types'

const props = defineProps<{
  rankings: Player[]
  playAgain: () => void
  myPlayerId?: string
}>()

// Función para verificar si es el jugador actual
const isMe = (playerId: string) => {
  return props.myPlayerId && playerId === props.myPlayerId
}
</script>

<template>
  <div class="flex flex-col items-center justify-center min-h-screen p-6">
    <div class="glass rounded-3xl p-6 max-w-md w-full animate-fade-in">
      <h2 class="text-3xl font-bold text-white text-center mb-6">🏆 RESULTADOS</h2>

      <div class="space-y-3 mb-6">
        <div
          v-for="(player, index) in rankings"
          :key="player.id"
          class="flex items-center gap-3 bg-white/10 rounded-xl p-4"
        >
          <span class="text-2xl">{{ ['🥇','🥈','🥉'][index] || '' }}</span>
          <span class="text-white flex-1 text-left">{{ player.name }}<span v-if="isMe(player.id)" class="text-teal-200 text-xs ml-1">(tú)</span></span>
          <span class="text-accent font-bold text-xl">{{ player.score }} pts</span>
        </div>
      </div>

      <button
        @click="playAgain"
        class="w-full py-4 px-6 bg-accent text-dark font-bold rounded-xl text-lg hover:scale-105"
      >
        🔄 Jugar de Nuevo
      </button>
    </div>
  </div>
</template>
